import { AdminSettings, BlockedDate, Booking, Product } from './types'

const STORAGE_KEYS = {
  products: 'np_products',
  bookings: 'np_bookings',
  blockedDates: 'np_blocked_dates',
  settings: 'np_settings',
}

const emptySettings: AdminSettings = {
  termsText: '',
  contactInfo: { name: '', phone: '', email: '' },
  emailJs: {
    publicKey: '',
    serviceId: '',
    templateId: '',
    notificationEmail: '',
  },
}

const readLegacy = <T,>(key: string, fallback: T): T => {
  try {
    const raw = localStorage.getItem(key)
    return raw ? (JSON.parse(raw) as T) : fallback
  } catch {
    return fallback
  }
}

export interface LegacyStoreData {
  products: Product[]
  bookings: Booking[]
  blockedDates: BlockedDate[]
  settings: AdminSettings
}

/**
 * Local storage is retained only so an authenticated administrator can perform
 * the one-time migration to Supabase. It is no longer read by the application.
 */
export const getLegacyStoreData = (): LegacyStoreData => ({
  products: readLegacy<Product[]>(STORAGE_KEYS.products, []),
  bookings: readLegacy<Booking[]>(STORAGE_KEYS.bookings, []),
  blockedDates: readLegacy<BlockedDate[]>(STORAGE_KEYS.blockedDates, []),
  settings: readLegacy<AdminSettings>(STORAGE_KEYS.settings, emptySettings),
})

export const hasLegacyStoreData = (): boolean => {
  const data = getLegacyStoreData()
  return (
    data.products.length > 0 ||
    data.bookings.length > 0 ||
    data.blockedDates.length > 0 ||
    Boolean(data.settings.termsText || data.settings.contactInfo.phone)
  )
}
